import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BUTTON_SIZE_MAP } from '@snack-uikit/input-private';
import { ButtonCopyValue } from '../helperComponents';
export function useCopyButton({ copyButtonRef, showCopyButton, size, valueToCopy, onValueRequest, onCopyButtonClick, disabled, prefix = '', postfix = '', }) {
    return useMemo(() => ({
        id: 'copy',
        active: true,
        ref: copyButtonRef,
        show: showCopyButton,
        render: props => (_jsx(ButtonCopyValue, Object.assign({}, props, { size: BUTTON_SIZE_MAP[size], valueToCopy: (prefix !== null && prefix !== void 0 ? prefix : '') + valueToCopy + (postfix !== null && postfix !== void 0 ? postfix : ''), onValueRequest: onValueRequest, onClick: onCopyButtonClick, disabled: disabled }))),
    }), [copyButtonRef, showCopyButton, size, prefix, valueToCopy, postfix, onValueRequest, onCopyButtonClick, disabled]);
}
